import { get, isEmpty } from 'lodash';
export { namespace } from './actions';
import { ActionType, Status, REGION_WORLD } from './actions';
import { TYPE_STANDARD, TYPE_RADIOMETRO, TYPE_DMA} from '../../../../components/Geofence/constant';

const initialState = {
  selectedIds: [],
  unratedIds: [],
  allUnratedIds: [],
  status: Status.STATUS_INITIAL,
  loadedRegions: {},
  currentSearch: {},
  selectionType: TYPE_DMA,
  includeUnidentifiedLocation: false
};


export default function geoSelectorReducer(state = initialState, action) {
  const { STATUS_LOADING, STATUS_LOADED, STATUS_INITIAL } = Status;
  switch(action.type) {
    case ActionType.SET_SELECTION:
      {
        const selectionInfo = action.payload || {};
        return {
          ...state,
          ...selectionInfo
        };
      }

    case ActionType.LOAD_SUB_REGION:
      {
        const loadedRegions = {...state.loadedRegions};
        const { id, level, type } = action.payload;
        const parentLevel = `level${level}`;
        const regionParent = get(loadedRegions, [parentLevel, id]);
        if (id !== REGION_WORLD && regionParent) {
          switch (type) { //change loading status according to selectionType
            case TYPE_STANDARD:
              regionParent.loadingStatus = STATUS_LOADING; 
              break;
            case TYPE_RADIOMETRO:
              regionParent.radioMetroLoadingStatus = STATUS_LOADING; 
              break;
            case TYPE_DMA:
              regionParent.dmaLoadingStatus = STATUS_LOADING; 
              break;
          }
        }

        return {
          ...state,
          loadedRegions
        };
      }

    case ActionType.SET_REGION_DATA:
      {
        const {
          data,
          type,
          parentId,
          parentLevel,
          lastParentId,
          isUnrated,
          keepLoadingInitial
        } = action.payload;
        const loadedRegions = {...state.loadedRegions};
        const notCountryData = parentId !== REGION_WORLD;
        const parentLevKey = `level${parentLevel}`;
        const objParent = notCountryData && get(loadedRegions, [parentLevKey, lastParentId]);
        const childData = objParent? [...objParent.children]: [];
        if( !isEmpty(data) ){
          const currentLevel = `level${parseInt(parentLevel)+1}`;
          const loadedRegionData = get(state, ["loadedRegions", currentLevel], {});
          const subRegionData = notCountryData? get(data, [lastParentId], []) : data;
          const newLevel = subRegionData.reduce((countries, currentEntry) => {
            const id = currentEntry.criterial_id;
            currentEntry.id = id.toString();
            currentEntry.children = [];
            currentEntry.parentId = notCountryData? currentEntry.parentIdTree.join('-') : parentId;
            currentEntry.loadingStatus = isUnrated? STATUS_LOADED : STATUS_INITIAL;
            currentEntry.level = parseInt(parentLevel)+1;
            currentEntry.fetchType = type;
            currentEntry.isUnrated = isUnrated;

            //set initial loading status for metro
            if (currentEntry.radioMetro) { 
              const status = isUnrated? STATUS_LOADED : STATUS_INITIAL;
              currentEntry.radioMetroLoadingStatus = status;
            }
            
            //set initial loading status for DMA
            if (currentEntry.dma) {
              const status = isUnrated? STATUS_LOADED : STATUS_INITIAL;
              currentEntry.dmaLoadingStatus = status;
            }

            if (countries[id]) { //if the region already exist, save previous parents
              const { parentIdTree, parentId, parent_id, market_id, fetchType: previousType } = countries[id];
              const previousTypeInfo = `${previousType}Info`;
              currentEntry[previousTypeInfo] = {
                parentIdTree,
                parentId,
                parent_id,
                market_id
              }
              countries[id] = {...countries[id], ...currentEntry};
            } else {
              countries[id] = currentEntry;
            }

            //if there's parent and currentEntry hasn't added into children array
            if (objParent && !childData.includes(id.toString())) {  
              childData.push(id.toString());
            }
            return countries;
          }, loadedRegionData);
          loadedRegions[currentLevel] = newLevel;
        }
        if (objParent) {  //if parent exist set children and loadingStatus for parent
          const { loadingStatus, dmaLoadingStatus, metroLoadingStatus } = objParent;
          switch (type) {
            case TYPE_STANDARD:
              objParent.loadingStatus = keepLoadingInitial && loadingStatus !== STATUS_LOADED? STATUS_INITIAL: STATUS_LOADED;
              break;
            case TYPE_RADIOMETRO:
              objParent.radioMetroLoadingStatus = keepLoadingInitial && metroLoadingStatus !== STATUS_LOADED? STATUS_INITIAL:STATUS_LOADED;
              break;
            case TYPE_DMA:
              objParent.dmaLoadingStatus = keepLoadingInitial && dmaLoadingStatus !== STATUS_LOADED? STATUS_INITIAL:STATUS_LOADED;
              break;
          }
          objParent.children = childData;
        }
        return {...state, loadedRegions }
      }
    
    case ActionType.SET_SEARCH_RESULT:
      {
        const { searchResult } = action.payload;
        return {
          ...state,
          currentSearch: searchResult,
        }
      }
    
    case ActionType.LOAD_UNRATED_MARKET:
      {
        return {
          ...state,
          status: Status.STATUS_LOADING
        }
      }
    
    case ActionType.SET_UNRATED_MARKET:
      {
        const { unratedIds } = action.payload;
        return {
          ...state,
          unratedIds: [...unratedIds],
          status: Status.STATUS_LOADED
        }
      }
    
  default:
    return state;
  }
}
